import './EmailTemplatePreview.scss';
import React from 'react';
import InfoIcon from '/src/assets/icons/info-icon.svg';
import EmailPreviewContent from './EmailPreviewContent';
import type { TEmailPreviewData } from 'components/FlowBuilder/FlowSidePanels/types';

const MAIN_CLASS = `email-template-preview`;
const CLASSES = {
  HEADER: `${MAIN_CLASS}__header`,
  NO_INFO: `${MAIN_CLASS}__noInfo`,
  WITH_INFO: `${MAIN_CLASS}__withInfo`,
  PREVIEW_LABEL: `${MAIN_CLASS}__preview-label`,
  PREVIEW_DESC: `${MAIN_CLASS}__preview-desc`,
  INFO_LABEL: `${MAIN_CLASS}__info-label`,
  TEMPLATE_AREA: `${MAIN_CLASS}__template-area`,
  SELECT_TEMPLATE: `${MAIN_CLASS}__select-template`,
  BLUE_SPAN: `${MAIN_CLASS}__blue-span`,
};

interface EmailTemplatePreviewProps {
  previewData?: TEmailPreviewData | null;
  isLoading: boolean;
  isTemplateError?: boolean;
}

function EmailTemplatePreview({ previewData, isLoading, isTemplateError }: EmailTemplatePreviewProps) {
  return (
    <div className={previewData ? CLASSES.WITH_INFO : CLASSES.NO_INFO}>
      <div className={CLASSES.HEADER}>
        <div className={CLASSES.PREVIEW_LABEL}>Preview</div>
        <div className={CLASSES.PREVIEW_DESC}>
          {previewData ? (
            <span>
              This is a simulated preview of what the email message will look like.{' '}
              <span className={CLASSES.BLUE_SPAN}>Blue text</span> in the preview are tags defined in the SendGrid
              template.
            </span>
          ) : (
            <span>This is a preview of the template you created in SendGrid</span>
          )}
        </div>
      </div>
      {previewData && (
        <div className={CLASSES.INFO_LABEL}>
          <img src={InfoIcon} alt="Information icon" />
          <span>This is only a simulated preview and may not be exactly what appears on the end device</span>
        </div>
      )}
      <div className={CLASSES.TEMPLATE_AREA}>
        {previewData ? (
          <EmailPreviewContent {...previewData} isLoading={isLoading} />
        ) : isTemplateError ? (
          <span className={`${CLASSES.SELECT_TEMPLATE} ${CLASSES.SELECT_TEMPLATE}__centered`}>
            Preview unavailable as we were unable to fetch this template. Please reload the page or try again later.
          </span>
        ) : (
          <span className={`${CLASSES.SELECT_TEMPLATE} ${CLASSES.SELECT_TEMPLATE}__centered`}>Select a template</span>
        )}
      </div>
    </div>
  );
}

export default EmailTemplatePreview;
